import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsersListRequest } from "../../../AdminPanel/features/users/usersSlice";

const USERS_PAGE_NUMBER = 1;
const USERS_PAGE_SIZE = 2000;

export function useCurrentUserOwner() {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.sessionContextOidc?.userView);
  const users = useSelector((state) => state.adminPanel.usersData.usersList);
  const currentUserId = currentUser?.id != null ? String(currentUser.id) : "";

  useEffect(() => {
    dispatch(
      fetchUsersListRequest({
        page_number: USERS_PAGE_NUMBER,
        page_size: USERS_PAGE_SIZE,
        deleted: false,
        type: 'activity'
      }),
    );
  }, [dispatch]);

  return { currentUser, currentUserId, users };
}